import Axios from "axios";
import React from "react";
import { Badge } from "react-bootstrap";
import { sortCaret } from "../../../_metronic/_helpers";
import axiosCancel from 'axios-cancel';

axiosCancel(Axios);
const url_tasks = process.env[`REACT_APP_${process.env.REACT_APP_ENV.toUpperCase()}_URL`] + "/v1/tasks";
console.log(process.env.NODE_ENV);

function ActionsColumnFormatter(cellContent, row, rowIndex) {
  const types = {
    "File (photo)": "success",
    Rate: "warning",
    Comment: "info",
    "Yes/No": "primary",
    Quantity: "danger",
  };
  return (
    <h5>
      {row.input_type.map((input, key) => (
        <Badge key={key} variant={types[input] || "danger"} className="p-2 mx-1">
          {input || "null"}
        </Badge>
      ))}
    </h5>
  );
}

export const columns = [
  {
    dataField: "count",
    text: "No",
    headerStyle: {
      width: "50px",
    },
  },
  {
    dataField: "name",
    text: "Task Title",
    sort: true,
    sortCaret: sortCaret,
    headerStyle: {
      width: "300px",
    },
  },
  {
    dataField: "description",
    text: "Description",
    sort: true,
    sortCaret: sortCaret,
    headerStyle: {
      width: "300px",
    },
  },
  {
    dataField: "input_type",
    text: "Required Actions",
    sort: true,
    sortCaret: sortCaret,
    formatter: ActionsColumnFormatter,
    headerStyle: {
      width: "500px",
    },
  },
  {
    dataField: "input_type",
    text: "Graphs",
    sort: true,
    sortCaret: sortCaret,
    formatter: (value, row) => <>{(row.charts ?? []).join(", ")} </>,
  },
];

export function getClients(setCategory) {
  Axios.get(`${url_tasks}/find`)
    .then((res) => {
      const categories = res.data.payload;
      console.log(categories);
      setCategory(categories);
    })
    .catch(function (thrown) {
      if (Axios.isCancel(thrown)) {
        console.log(`request cancelled:${thrown.message}`)
      } else {
        console.log('another error happened')
      }
    })
}
export function getClient(uid = "") {
  return Axios.get(`${url_tasks}/find/${uid}`);
}
export function updateClient(tasks) {
  if (tasks.uid) {
    return Axios.put(`${url_tasks}/update/${tasks.uid}`, tasks);
  } else {
    return Axios.post(`${url_tasks}/create`, tasks);
  }
}
export function deleteClient(uid) {
  return Axios.delete(`${url_tasks}/delete/${uid}`);
}